<template>
<v-list>
    <template v-for='group in groups' >
    <!-- <v-subheader :key='group.id'>{{group.name}}
        <v-spacer></v-spacer>
        <v-btn v-if='withActivate' @click='$emit("groupSelected", group)' flat small >Activate</v-btn>
    </v-subheader>
    <v-divider :key='`divider-${group.id}`' ></v-divider> -->
    <data-list :key='`group-${group.id}`' class="pa-0"
        @selected='emitSelected'
        :items='group.data'
        title-path='first_name'
        sub-title-path='profile.practice_name'
        avatar-path='profile.profile_picture'
        avatar-position='after' >
        <template slot='title' slot-scope='props' >
            {{props.item.first_name}} {{props.item.last_name}}
        </template>
        <template slot='avatar-after' slot-scope="props" >
          <v-list-tile-avatar >
            <img v-if='props.item.profile && props.item.profile.profile_picture' :src='props.item.profile.profile_picture' />
            <v-icon v-else >account_circle</v-icon>
          </v-list-tile-avatar>
        </template>
    </data-list>
    </template>
</v-list>
</template>

<script>
import DataList from '@/components/ui/DataList'

export default {
  name: 'GroupedPractitionerPicker',
  components: {DataList},
  props: {
    groups: { type: Array, default: () => { return [] } },
    withActivate: { type: Boolean, default: true }
  },
  methods: {
    emitSelected (item) {
      this.$emit('selected', item)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// GroupedPractitionerPicker.vue?4a7b62ec